import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React from 'react';
import { useState, useEffect, useCallback, useRef, useMemo } from 'react';
import { TelemetryContext } from './TelemetryContext';

/**
 * The context provider that passes the telemetry instance to the context so it can be consumed by all the child components
 */
export var TelemetryProvider = function TelemetryProvider(_ref) {
  var children = _ref.children,
      telemetryParam = _ref.telemetry;
  var isFmpReported = useRef(false);

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      componentCount = _useState2[0],
      setComponentCount = _useState2[1];

  var firstMeaningfulContent = useRef(new Set());

  var _useState3 = useState(telemetryParam),
      _useState4 = _slicedToArray(_useState3, 2),
      telemetry = _useState4[0],
      setTelemetry = _useState4[1];

  useEffect(function () {
    if (!isFmpReported.current && componentCount === 0) {
      var _performance$timing;

      isFmpReported.current = true;
      telemetry.reportPerformance('FMP', {
        fmp: Date.now() - ((_performance$timing = performance.timing) === null || _performance$timing === void 0 ? void 0 : _performance$timing.navigationStart)
      });
    }
  }, [telemetry, componentCount]);
  var registerToFirstMeaningfulContent = useCallback(function (component) {
    firstMeaningfulContent.current.add(component);
    setComponentCount(firstMeaningfulContent.current.size);
  }, []);
  var unRegisterToFirstMeaningfulContent = useCallback(function (component) {
    if (firstMeaningfulContent.current.size > 0) {
      firstMeaningfulContent.current.delete(component);
      setComponentCount(firstMeaningfulContent.current.size);
    }
  }, []);
  var telemetryContextValue = useMemo(function () {
    return {
      telemetry: telemetry,
      registerToFirstMeaningfulContent: registerToFirstMeaningfulContent,
      unRegisterToFirstMeaningfulContent: unRegisterToFirstMeaningfulContent,
      setTelemetry: setTelemetry
    };
  }, [telemetry, registerToFirstMeaningfulContent, unRegisterToFirstMeaningfulContent]);
  return /*#__PURE__*/React.createElement(TelemetryContext.Provider, {
    value: telemetryContextValue
  }, children);
};
//# sourceMappingURL=TelemetryProvider.js.map